import { useMemo } from "react";
import { useIssuesStore } from "@/store/zustand/issues-store";
import { Project, Canvas } from "../constants";

interface UseIssueDataProps {
  canvas?: Canvas;
  project?: Project;
}

export const useIssueData = ({ canvas, project }: UseIssueDataProps) => {
  // Get current issue from the new store structure
  const currentIssue = useIssuesStore(
    (state) => state.canvasIdToIssue[canvas?.id ?? ""],
  );

  const issue = useMemo(() => {
    return currentIssue;
  }, [currentIssue]);

  const issueData = useMemo(() => {
    const data: any = {};
    if (issue) {
      data.issueIds = issue.canvas.labels || [];
      data.labelInterfaces = (issue.canvas.labels || []).map((l) => {
        const projectLabels = (project?.labels || project?.labels) as any[];

        const projectLabel = projectLabels?.find((pl) => pl.id === l);
        return {
          id: l,
          label: projectLabel?.label,
          name: projectLabel?.name,
          color: projectLabel?.color,
        };
      });
    } else if (canvas) {
      data.issueIds = (canvas.labels as unknown as string[]) ?? [];
      data.labelInterfaces = data.issueIds.map((l) => {
        const projectLabels = (project?.labels || project?.labels) as any[];
        const projectLabel = projectLabels?.find((pl) => pl.id === l);
        return {
          id: l,
          label: projectLabel?.label,
          name: projectLabel?.name,
          color: projectLabel?.color,
        };
      });
    }
    return data;
  }, [issue, canvas, project?.labels]);

  return {
    issue,
    issueData,
  };
};
